import { render, staticRenderFns } from "./AsignacionItems.vue?vue&type=template&id=63104a7a&scoped=true"
import script from "./AsignacionItems.vue?vue&type=script&lang=js"
export * from "./AsignacionItems.vue?vue&type=script&lang=js"
import style0 from "./AsignacionItems.vue?vue&type=style&index=0&id=63104a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63104a7a",
  null
  
)

export default component.exports